<div class="main px-5">
  <div class="col-12 mt-3 py-2 px-5 bg-light-color" [class.d-none]="route.children.length !== 0">
    <div class="col-12 d-flex mt-3 justify-content">
      <div class="d-flex col-10">
        <h1 class="fs-4 fw-bold text-primary-color mt-3">Vínculos</h1>
      </div>
      <div class="d-flex px-5">
        <ng-template [ngxPermissionsOnly]="[roleEnum.VinculoGravacao]">
          <button nz-button type="button" nzType="primary" [nzSize]="size" class="rounded-pill" (click)="novo()">
            Adicionar Vínculo
          </button>
        </ng-template>
      </div>
    </div>

    <nz-divider class="m-0 p-0 mt-2 mb-4"></nz-divider>

    <div class="d-flex">
      <div class="col-12 contrato-content pl-0 pr-0 border-gray box-shadow">
        <div #contratoContainer>
          <form [formGroup]="vinculoFilterForm" id="vinculoFilterForm">
            <div class="row row-cols-2 row-cols-md-4 g-4 mb-2">
              <ng-template [ngxPermissionsOnly]="[roleEnum.VinculoLeitura]">

                <div class="col-md-6 form-group" nz-tooltip
                  nzTooltipTitle="Digite ao menos as três primeiras letras do nome para iniciar a busca">
                  <label for="entidadesId" class="form-label">Entidade</label>
                  <nz-select formControlName="entidadesId" nzShowSearch nzServerSearch nzAllowClear
                    nzPlaceHolder="Digite o nome da entidade" nzSize="large"
                    [nzMode]="'multiple'" [nzFilterOption]="nzFilterOption"
                    (nzOnSearch)="loadEntidadeCombo($event)">
                    <nz-option [nzValue]="item.id" [nzLabel]="item.nome" *ngFor="let item of entidadeList" />
                  </nz-select>
                </div>


                <div class="col-md-6 form-group" nz-tooltip
                  nzTooltipTitle="Digite ao menos as três primeiras letras do nome para iniciar a busca">
                  <label for="entidadeRepresentadaId" class="form-label">Nome Entidade Representada</label>
                  <nz-select formControlName="entidadeRepresentadaId" nzShowSearch nzServerSearch nzAllowClear
                    nzPlaceHolder="Digite o nome da entidade" nzSize="large" [nzFilterOption]="nzFilterOption"
                    (nzOnSearch)="loadEntidadeRepresentadaCombo($event)">
                    <nz-option [nzValue]="item.id" [nzLabel]="item.nome" *ngFor="let item of entidadeRepresentadaList" />
                  </nz-select>
                </div>
                <div class="col-md-6 form-group" nz-tooltip
                  nzTooltipTitle="Digite ao menos as três primeiras letras do nome para iniciar a busca">
                  <label for="pessoa" class="form-label">Pessoa</label>
                  <nz-select id="pessoa" nzShowSearch nzServerSearch nzPlaceHolder="Digite o nome da pessoa"
                    formControlName="pessoa" [nzShowArrow]="false" [nzFilterOption]="nzFilterOption" nzSize="large"
                    [nzAllowClear]="true" (nzOnSearch)="loadEntidadesSuperior($event)">
                    <nz-option [nzValue]="item.id" [nzLabel]="item.nomeCpf" *ngFor="let item of nomePessoaList" />
                  </nz-select>
                </div>

                <div class="col-md-6 form-group">
                  <label for="email" class="form-label">Email</label>
                  <nz-input-group nzSize="large">
                    <input nz-input id="email" formControlName="email" placeholder="Digite o email"/>
                  </nz-input-group>
                </div>

                <div class="col-md-2 form-group">
                  <label for="cargoVinculos" class="form-label">Cargos</label>
                  <nz-select formControlName="cargoVinculos" nzShowSearch nzAllowClear nzPlaceHolder=" - "
                    nzSize="large" [nzMode]="'multiple'" [nzFilterOption]="filtrarOpcaoSemAcento">
                    <nz-option [nzValue]="item.id" [nzLabel]="item.nomeCargoReferencia"
                      *ngFor="let item of cargoVinculosList" />
                  </nz-select>
                </div>

                <div class="col-md-2 form-group">
                  <label for="tipoEntidadeId" class="form-label">Tipos de entidade</label>
                  <nz-select formControlName="tipoEntidadeId" nzShowSearch nzAllowClear nzPlaceHolder="Tipo de entidade"
                    nzSize="large" nzMode="multiple" [nzFilterOption]="filtrarOpcaoSemAcento">
                    <nz-option [nzValue]="item?.id" [nzLabel]="item?.nomeTipoEntidade"
                        *ngFor="let item of tipoEntidadeList" />
                  </nz-select>
                </div>

                <div class="col-md-2 form-group">
                  <label for="federacaoQueIndicou" class="form-label">Federação que indicou</label>
                  <nz-select formControlName="federacaoQueIndicou" nzShowSearch nzAllowClear nzPlaceHolder=" - "
                    nzSize="large" nzMode="multiple" [nzFilterOption]="filtrarOpcaoSemAcento">
                    <nz-option [nzValue]="item.id" [nzLabel]="item.nomeFantasia"
                      *ngFor="let item of nomeFederacaoList" />
                  </nz-select>
                </div>

                <div class="col-md-2 form-group">
                  <label for="entidadeFederacao" class="form-label">Entidades Por Federação</label>
                  <nz-select formControlName="entidadeFederacao" nzShowSearch nzAllowClear nzPlaceHolder=" - "
                    nzSize="large" nzMode="multiple" [nzFilterOption]="filtrarOpcaoSemAcento">
                    <nz-option [nzValue]="item.id" [nzLabel]="item.nomeFantasia"
                      *ngFor="let item of nomeFederacaoList" />
                  </nz-select>
                </div>


                <div class="col-md-3 form-group">
                  <label for="pertenceA" class="form-label">Pertence A</label>
                  <nz-select formControlName="pertenceA" nzShowSearch nzAllowClear nzPlaceHolder="pertenceA" nzSize="large"
                   nzMode="multiple" [nzFilterOption]="filtrarOpcaoSemAcento">
                    <nz-option [nzValue]="item?.id" [nzLabel]="item?.nomeFantasia" *ngFor="let item of pertenceList" />
                  </nz-select>
                </div>

                <div class="col-md-3 form-group">
                  <label for="tipoVinculo" class="form-label">Tipos De Vinculo</label>
                  <nz-select formControlName="tipoVinculo" nzShowSearch nzAllowClear nzPlaceHolder=" - " nzSize="large"
                    [nzMode]="'multiple'" [nzFilterOption]="filtrarOpcaoSemAcento">
                    <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoVinculo"
                      *ngFor="let item of tipoVinculoList" />
                  </nz-select>
                </div>

                <div class="col form-group">
                  <label for="status" class="form-label">Status</label>
                  <nz-select formControlName="status" nzShowSearch nzAllowClear nzPlaceHolder=" - " nzSize="large"
                    [nzMode]="'multiple'" [nzFilterOption]="filtrarOpcaoSemAcento">
                    <nz-option [nzValue]="item.id" [nzLabel]="item.nomeStatusValidacao"
                      *ngFor="let item of statusValidacaoList" />
                  </nz-select>
                </div>


              </ng-template>
            </div>
            <div class="legenda pt-2">
              <div class="item">
                <span class="cor vermelho"></span> <span>Vermelho - Indica que o registro está finalizado</span>
              </div>
              <div class="item">
                <span class="cor roxo"></span> <span>Roxo - Indica que o registro está expirado e ainda não foi finalizado</span>
              </div>
            </div>

            <div class="form-group d-flex justify-content-end ml-3">
              <button nz-button type="button" nzType="primary" [nzSize]="size" class="rounded-pill mt-4 me-3"
                form="vinculoFilterForm" (click)="pesquisar()">
                Pesquisar
              </button>
              <button nz-button type="button" nzType="default" [nzSize]="size" class="rounded-pill mt-4"
                (click)="reset()">
                Limpar Filtros
              </button>
            </div>
          </form>

          <nz-divider class="m-0 p-0 mt-4"></nz-divider>

          <div class="d-flex flex-column page-content border border-radius w-100" id="vinculoList">
            <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
              [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate"
              [nzLoading]="loadingTabela"
              [nzScroll]="{ x: 'max-content' }">
              <thead>
                <tr>
                  <th class="sortable-header" nzColumnKey="nomeEntidade" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="250px"
                    [nzSortOrder]="sortOrderOf('nomeEntidade')"
                    (mousedown)="rememberShift($event, 'nomeEntidade')"
                    (nzSortOrderChange)="onColumnSort('nomeEntidade', $event)"
                    nz-tooltip
                    nzTooltipTitle="Shift + clique para ordenar por mais de uma coluna">
                    Entidade
                    <span class="sort-priority" *ngIf="sortPriorityOf('nomeEntidade') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="cargoVinculo" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="150px"
                    [nzSortOrder]="sortOrderOf('cargoVinculo')"
                    (mousedown)="rememberShift($event, 'cargoVinculo')"
                    (nzSortOrderChange)="onColumnSort('cargoVinculo', $event)">
                    Cargo
                    <span class="sort-priority" *ngIf="sortPriorityOf('cargoVinculo') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="cargoReferencia" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="150px"
                    [nzSortOrder]="sortOrderOf('cargoReferencia')"
                    (mousedown)="rememberShift($event, 'cargoReferencia')"
                    (nzSortOrderChange)="onColumnSort('cargoReferencia', $event)">
                    Cargo de Referência
                    <span class="sort-priority" *ngIf="sortPriorityOf('cargoReferencia') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="principal" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="80px"
                    [nzSortOrder]="sortOrderOf('principal')"
                    (mousedown)="rememberShift($event, 'principal')"
                    (nzSortOrderChange)="onColumnSort('principal', $event)">
                    Principal
                    <span class="sort-priority" *ngIf="sortPriorityOf('principal') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="nomePessoa" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="250px"
                    [nzSortOrder]="sortOrderOf('nomePessoa')"
                    (mousedown)="rememberShift($event, 'nomePessoa')"
                    (nzSortOrderChange)="onColumnSort('nomePessoa', $event)">
                    Pessoa
                    <span class="sort-priority" *ngIf="sortPriorityOf('nomePessoa') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="entidadeRepresentada" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="250px"
                    [nzSortOrder]="sortOrderOf('entidadeRepresentada')"
                    (mousedown)="rememberShift($event, 'entidadeRepresentada')"
                    (nzSortOrderChange)="onColumnSort('entidadeRepresentada', $event)">
                    Entidade Representada
                    <span class="sort-priority" *ngIf="sortPriorityOf('entidadeRepresentada') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="cargoEntidadeRepresentada" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="250px"
                    [nzSortOrder]="sortOrderOf('cargoEntidadeRepresentada')"
                    (mousedown)="rememberShift($event, 'cargoEntidadeRepresentada')"
                    (nzSortOrderChange)="onColumnSort('cargoEntidadeRepresentada', $event)">
                    Cargo da Ent. Representado
                    <span class="sort-priority" *ngIf="sortPriorityOf('cargoEntidadeRepresentada') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="email" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="200px"
                    [nzSortOrder]="sortOrderOf('email')"
                    (mousedown)="rememberShift($event, 'email')"
                    (nzSortOrderChange)="onColumnSort('email', $event)">
                    E-mail
                    <span class="sort-priority" *ngIf="sortPriorityOf('email') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="tipoVinculo" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="120px"
                    [nzSortOrder]="sortOrderOf('tipoVinculo')"
                    (mousedown)="rememberShift($event, 'tipoVinculo')"
                    (nzSortOrderChange)="onColumnSort('tipoVinculo', $event)">
                    Tipo Vínculo
                    <span class="sort-priority" *ngIf="sortPriorityOf('tipoVinculo') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="inicioVinculo" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="110px"
                    [nzSortOrder]="sortOrderOf('inicioVinculo')"
                    (mousedown)="rememberShift($event, 'inicioVinculo')"
                    (nzSortOrderChange)="onColumnSort('inicioVinculo', $event)">
                    Início Vinculo
                    <span class="sort-priority" *ngIf="sortPriorityOf('inicioVinculo') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="ultimaAlteracao" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="110px"
                    [nzSortOrder]="sortOrderOf('ultimaAlteracao')"
                    (mousedown)="rememberShift($event, 'ultimaAlteracao')"
                    (nzSortOrderChange)="onColumnSort('ultimaAlteracao', $event)">
                    Última Alteração
                    <span class="sort-priority" *ngIf="sortPriorityOf('ultimaAlteracao') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="status" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="80px"
                    [nzSortOrder]="sortOrderOf('status')"
                    (mousedown)="rememberShift($event, 'status')"
                    (nzSortOrderChange)="onColumnSort('status', $event)">
                    Status
                    <span class="sort-priority" *ngIf="sortPriorityOf('status') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="text-center" nzWidth="80px" [nzRight]="true">Ações</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="paginator?.paginaAtual">
                  <tr *ngFor="let item of dataSet" [class.text-purple-color]="isExpiradaAndAtivo(item)" [class.text-danger]="isInativo(item)">
                    <td>{{ item?.nomeEntidade }}</td>
                   <td>{{ item?.cargoVinculo }}</td>
                    <td>{{ item?.cargoReferencia }}</td>
                    <td>{{ item?.principal ? 'Sim' : 'Não' }}</td>
                    <!-- <td>{{ item?.pertenceA }}</td> -->
                    <td>{{ item?.nomePessoa }}</td>
                    <td>{{ item?.entidadeRepresentada }}</td>
                    <td>{{ item?.cargoEntidadeRepresentada }}</td>
                    <td>{{ item?.email }}</td>
                    <td>{{ item?.tipoVinculo }}</td>
                    <td>{{ item?.inicioVinculo }}</td>
                    <td>{{ item?.dataUltimaAtualizacao }}</td>

                    <!-- <td>{{ item?.fimVinculo }}</td>
                    <td>{{ item?.inicioMandato }}</td>
                    <td>{{ item?.fimMandato }}</td>-->
                    <td>{{ item?.status }}</td>
                    <td class="text-center" [nzRight]="true">
                      <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                        <span nz-icon nzType="more" nzTheme="outline"></span>
                      </button>
                      <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu>
                          <!-- <li nz-menu-item (click)="exportar(item)">
                            <a>Exportar</a>
                          </li> -->
                          <ng-template [ngxPermissionsOnly]="[roleEnum.VinculoLeitura]">
                            <li nz-menu-item (click)="editar(item)">
                              <a>Editar/Consultar</a>
                            </li>
                            <ng-template [ngxPermissionsOnly]="[roleEnum.VinculoExclusao]">
                              <li nz-menu-item (click)="remover(item)">
                                <a>Remover</a>
                              </li>
                            </ng-template>
                            <ng-template [ngxPermissionsOnly]="[perfilEnum.Administrador, perfilEnum.Validador]" *ngIf="item?.status === 'Finalizado'">
                              <li nz-menu-item (click)="reativar(item)">
                                <a>Reativar</a>
                              </li>
                            </ng-template>

                          </ng-template>
                        </ul>
                      </nz-dropdown-menu>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </nz-table>
            <ng-template #footerTemplate>
              <section class="d-flex justify-content-end w-100">
                <app-pagination [itemPorPagina]="10"></app-pagination>
              </section>
            </ng-template>
            <ng-template #semDadosTemplate>
              <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
                <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="d-flex w-100 justify-content-end align-items-center mt-3">
          <ng-template [ngxPermissionsOnly="[role.Administracao]">
            <eds-popover class="menu-exportar-actions" targetClass="exportar-actions" position="bottom">
              <td class="text-center">
                <button nz-button nz-dropdown [nzDropdownMenu]="menu" nzType="primary" [nzSize]="size" nzShape="circle">
                  <span nz-icon nzType="download"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <!-- <li nz-menu-item (click)="exportarExcel()">
                      <i class="fi fi-rr-file-excel pe-1"></i>
                      <a>Exportar Excel</a>
                    </li> -->
                  </ul>
                </nz-dropdown-menu>
              </td>
            </eds-popover>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <router-outlet></router-outlet>
</div>
